import React from 'react';

const WidgetIcon = () => {
  return (
    <div>
      <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="3" width="7" height="7" rx="1" stroke="#044E97" stroke-width="2" stroke-linecap="round"/>
<rect x="3" y="14" width="7" height="7" rx="1" stroke="#044E97" stroke-width="2" stroke-linecap="round"/>
<rect x="14" y="3" width="7" height="7" rx="1" stroke="#044E97" stroke-width="2" stroke-linecap="round"/>
<path d="M17.5 14L17.5 21.0002" stroke="#044E97" stroke-width="2" stroke-linecap="round"/>
<path d="M21 17.5L13.9998 17.5" stroke="#044E97" stroke-width="2" stroke-linecap="round"/>
</svg>
    </div>
  );
};

export { WidgetIcon };
